import { render, staticRenderFns } from "./PermissionGuard.vue?vue&type=template&id=7034f5cc&"
import script from "./PermissionGuard.vue?vue&type=script&lang=js&"
export * from "./PermissionGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports